import api from '../../utils/api';

export interface SalesTaxResponse {
  data: SalesTax[];
  more_records: boolean;
  size: number;
  total: number;
  _links: {
    self: string;
    next: string;
    prev: string;
  };
}

export interface SalesTax {
  id: string;
  tenant_id: string;
  division_id: string;
  tax_id?: string;
  rate?: number;
  name?: string;
  is_active?: boolean;
}

export interface CreateSalesTaxParams {
  division_id: string;
  tax_id?: string;
  rate?: number;
  name?: string;
  is_active?: boolean;
}

class SalesTaxService {
  static async getSalesTaxSettings(
    divisionId: string,
    params?: any,
    filters?: any
  ): Promise<SalesTax[]> {
    const response = await api.post(
      `/sales-tax/search?${Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join('&')}`,
      {
        division_id: divisionId,
        ...filters
      }
    );

    return response.data.data;
  }

  static async createSalesTax(params: CreateSalesTaxParams): Promise<SalesTax> {
    const response = await api.post(`/sales-tax`, params);
    return response.data;
  }

  static async updatePartialSalesTax(id: string, params: Partial<SalesTax>): Promise<SalesTax> {
    const response = await api.patch(`/sales-tax/${id}`, params);
    return response.data;
  }

  static async deleteSalesTax(id: string): Promise<void> {
    await api.delete(`/sales-tax/${id}`);
  }
}

export default SalesTaxService;
